import React from 'react';
import { put, select } from 'redux-saga/effects';
import Notification from '@/components/common/notification';
import List from '@/components/common/list';
import Alert from '@/components/common/alert';
import { HTTP_CODE } from '@/common/constant';
import { REFRESH_TOKEN } from '@/store/types/authenticate';

/**
 * Handle show message request failed
 * @param {*} param0
 * @returns
 */
export function showMessageFailed({ error = null }) {
  const { responseError = null } = error;
  if (!responseError) return;

  let { message, data: msgData, error_description, requestId } = responseError.data;
  let msgDescription = null;
  if (responseError.status >= 500 || [400, 401, 403].includes(responseError.status)) {
    message = (
      <div className="notification-request-error">
        <p>{message}</p>
        <span>Error code: {requestId}</span>
      </div>
    );
  }
  if (responseError.status === HTTP_CODE[422] && msgData) {
    const messageEls = Object.values(msgData).map((el) => (el.length ? el[0] : null));
    msgDescription = (
      <Alert
        message={<List size="small" bordered={false} dataSource={messageEls} />}
        type="error"
        className="notification-request-error"
      />
    );
  }

  Notification({
    type: 'error',
    message: message || error_description,
    description: msgDescription,
  });
}

/**
 * Handle response was failed from request
 * @param {*} param0
 * @returns
 */
function* onFailRequest({ ...args }) {
  const { err = null, error = null, onCallback = null, isAllowShowError = true } = args;
  const { authenticate } = yield select();
  const { responseError = null } = err || error;
  if (!responseError) return;

  if (responseError.status === HTTP_CODE[401]) {
    if (!authenticate.isRefreshToken) {
      yield put({
        type: REFRESH_TOKEN,
      });
    }
  }
  if (isAllowShowError) {
    showMessageFailed({ error });
  }
  if (onCallback) {
    yield onCallback();
  }
}

/**
 * Handle response succeed from request
 * @param {*} args
 */
function* onSuccessRequest(args) {
  const {
    // payload,
    response = null,
    onCallback = null,
    isAllowShowMsg = true,
  } = args;

  const { message } = response;

  if (isAllowShowMsg) {
    Notification({ type: 'success', message });
  }

  if (onCallback) {
    yield onCallback();
  }
}

/**
 * Custom transform request upload file
 */
const multiPartUpload = {
  transformRequest: [
    (data, headers) => {
      const formData = new FormData();
      Object.keys(data).forEach((val) => {
        if (data[val] !== undefined && data[val] !== null) formData.append(val, data[val]);
      });
      headers['Content-Type'] = 'multipart/form-data';
      return formData;
    },
  ],
};

export const validationRequiredText = (name, action = 'input') => {
  return `Please ${action} the ${name}!`;
};

export { onFailRequest, onSuccessRequest, multiPartUpload };
